import { defineMessages } from 'react-intl';

const translations = {
  printingFailedDialog: {
    actions: {
      close: {
        id: 'printingFailedDialog.actions.close',
        defaultMessage: 'Close',
        description: 'label of the close button',
      },
      download: {
        id: 'printingFailedDialog.actions.download',
        defaultMessage: 'Download',
        description: 'label of the download button',
      },
      retry: {
        id: 'printingFailedDialog.actions.retry',
        defaultMessage: 'Retry',
        description: 'label of the retry button',
      },
    },
  },
};

export default defineMessages(translations);
